document.addEventListener("DOMContentLoaded", function() {
  const wrappers = document.querySelectorAll('.hartu-product-title-wrapper');

  wrappers.forEach((wrapper) => {
    const link = wrapper.querySelector('.hartu-product-title');
    const originalText = link.innerText;
    const containerWidth = wrapper.offsetWidth;
    const textWidth = link.scrollWidth;

    if (textWidth > containerWidth) {
      wrapper.setAttribute('data-tooltip', originalText);
    } else {
      wrapper.removeAttribute('data-tooltip'); // Optional: Remove if no truncation
    }
  });
  
  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-follow-url]');
    if (target) {
      event.preventDefault();
      const followUrl = target.getAttribute('data-follow-url');
      if (followUrl) {
        window.location.href = followUrl;
      }
    }
  });

});
